import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store  from '@/store'
import { supabase } from '@/utils/supabase'
import ElementUI from 'element-ui';
//import drag from "v-drag"//https://gitcode.com/gh_mirrors/vd/v-drag 文档,最终在本案例中弃用，hammerjs.js
import 'element-ui/lib/theme-chalk/index.css';
import '@/permission' // permission control
Vue.prototype.$supabase = supabase
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
